<template>
    <div class="appstauberwidget" style="background-color: white; margin-bottom: 24px; border-radius: 8px;">
      <div class="appstauberwidget__header">
        <div class="appstauberwidget__header__label">
        Teamtip Benefits
        </div>
      </div>
      <app-stauber 
        data-mode="frontpage"
        data-header-z-index="1000"
        data-show-header="false"
        :data-external-ids=this.externalIds
        data-tenant-id="49615126692626431"
        :data-data-layer=this.dataLayer>
      </app-stauber>
      <div style="margin-right: 16px; margin-left: 16px; padding-bottom: 16px;">
        <a href="/benefits" @click="setAppstauberId()" class="button">{{ $t('show_all') }}</a>
        <!--<router-link :to="{name: 'appstauber'}" class="button" style="">Appstauber</router-link>-->
      </div>
    </div>
</template>

<script>
import {
  SPORTS_TYPE_DARTS,
  SPORTS_TYPE_FOOTBALL,
  SPORTS_TYPE_HANDBALL,
  SPORTS_TYPE_HOCKEY,
  SPORTS_TYPE_ICE_HOCKEY, SPORTS_TYPE_NFL,
  SPORTS_TYPE_OLYMPIA
} from '@/main'

export default {
  name: 'AppstauberWidget',
  components: {},
  beforeCreate () {
  },
  created () {
  },
  mounted () {
  },
  computed: {
    dataLayer() {
      var sportsType = 'Fussball'
      const c = this.$store.state.competitions.find(competition => competition.id === this.$store.state.betgame.competition.id)
      if(c) {
        const type = c.sports_type
        if (type === SPORTS_TYPE_FOOTBALL) {
          sportsType = 'Fussball'
        } else if (type === SPORTS_TYPE_HANDBALL) {
          sportsType = 'Handball'
        } else if (type === SPORTS_TYPE_HOCKEY) {
          sportsType = 'Hockey'
        } else if (type === SPORTS_TYPE_ICE_HOCKEY) {
          sportsType = 'Eishockey'
        } else if (type === SPORTS_TYPE_OLYMPIA) {
          sportsType = 'Olympia'
        } else if (type === SPORTS_TYPE_NFL) {
          sportsType = 'American Football'
        } else if (type === SPORTS_TYPE_DARTS) {
          sportsType = 'Darts'
        }
      }
      const data = {
        sport: sportsType,
        locale: navigator.language,
        locationCountry: '' + this.$store.state.geoData.Iso,
        uri: '/home',
        userIsAdmin: '' + (this.$store.state.betgame.fk_user === this.$store.state.user.id),
        userIsMinor: '' + !this.$store.state.user.isadult,
        isTenantAdmin: this.isSPMUser()
      }
      return JSON.stringify(data)
    },
    externalIds() {
      const data = {
        bid: '' + this.$store.state.betgame.id,
        uid: '' + this.$store.state.user.id,
      }
      return JSON.stringify(data)
    }
  },
  methods: {
    setAppstauberId() {
      if(this.$store.state.appstauberConfig) {
        this.$store.dispatch('setAppstauberId', this.$store.state.appstauberConfig.id) 
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.appstauberwidget {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: var(--color-surface);
  box-shadow: 0 0 1px 0 rgba(var(--color-text-rgb), .08), 0px 4px 16px rgba(var(--color-text-rgb), 0.08);
  border-radius: 8px;
  margin-bottom: 24px;

  &__header {
    display: flex;
    align-items: center;
    padding: 16px 16px 12px;
    color: var(--color-text);
    box-sizing: border-box;
    
    &__label {
      flex: 1;
      font-size: 17px;
      font-weight: 500;
    }

    &__select {
      position: relative;

      select {
        /* Reset */
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border: 0;
        background: none !important;

        /* New styles */
        font-size: 14px;
        color: var(--color-text);
        padding-right: 12px;
        text-align-last: right;

        &:focus, &:active {
          outline: none;
          color: #000000;
        }

        option {
          direction: rtl;
        }
      }

      select::-ms-expand {
        display: none;
      }

      &:before {
        position: absolute;
        content: url('../assets/icons/ic_12_dropdown.svg');
        right: 0;
        top: 1px;
        pointer-events: none;
      }
    }
  }

  &__content {
    position: relative;
    display: flex;
    justify-content: space-between;
    height: 160px;
    padding: 0 16px 12px;
    flex-direction: row-reverse;

    &__gutter {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: absolute;
      bottom: calc(22px + ((100% - 50%) / 10));
      left: 0;
      width: 100%;
      height: calc(100% - 50px - 12px);
      display: flex;
      flex-direction: column;

      span {
        width: 100%;
        height: 1px;
        background: rgba(var(--color-text-rgb), .06);
        margin: 1px 0;

        &:last-child {
          visibility: hidden;
        }
      }
    }
  }

  &__item {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    flex: 0 1 25%;
    justify-content: flex-end;
    align-items: center;

    .trendbox--many & {
      margin: 0 4px;

      &:first-child {
        margin: 0 0 0 4px;
      }

      &:nth-last-child(2) {
        margin: 0 4px 0 0;
      }

      span {
        display: none;
      }
    }
  }
  
  &__bar {
    width: 100%;
    max-width: 48px;
    height: 100%;
    font-size: 11px;
    font-weight: 500;
    color: var(--color-on-primary);
    text-align: center;
    padding: 5px 0 0;
    border-radius: 4px;
    min-height: 18px;
    box-sizing: border-box;

    &--zero {
      position: relative;
      width: 100%;
      max-width: 48px;
      font-size: 11px;
      font-weight: 500;
      color: #ACACAC;
      text-align: center;
      padding: 5px 0 0;
      border-radius: 4px;
      min-height: 18px;

      .trendbox__item--negative & {
        color: var(--color-negative);
      }

      &:before {
        position: absolute;
        content: '';
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        border-radius: 1px;
        background: rgba(var(--color-text-rgb), .08);

        .trendbox__item--negative & {
          background: var(--color-negative);
        }
      }
    }

    .trendbox__item--positive & {
      background: var(--color-positive);
    }
    .trendbox__item--middle & {
      background: var(--color-grey-mid);
    }
    .trendbox__item--negative & {
      background: var(--color-negative);
    }
    .trendbox__item--star & {
      background: var(--color-yellow);
      position: relative;

      &:before {
        content: '';
        position: absolute;
        width: 32px;
        height: 32px;
        top: -36px;
        left: 50%;
        transform: translateX(-50%);
        background: url('../assets/icons/ic_32_star.svg');
      }
    }
  }

  &__label {
    font-size: 11px;
    font-weight: 500;
    color: var(--color-grey-mid);
    margin-top: 6px;
    white-space: nowrap;
  }
}
</style>
